export const normaliseMapPosition = (latitudeValue, longitudeValue) => {
  const latitudeMissing =
    latitudeValue === null ||
    latitudeValue === undefined ||
    String(latitudeValue).trim() === "";
  const longitudeMissing =
    longitudeValue === null ||
    longitudeValue === undefined ||
    String(longitudeValue).trim() === "";

  if (latitudeMissing || longitudeMissing) return null;

  const latitude = Number(latitudeValue);
  const longitude = Number(longitudeValue);

  if (
    !Number.isFinite(latitude) ||
    !Number.isFinite(longitude) ||
    (latitude === 0 && longitude === 0) ||
    latitude < -90 ||
    latitude > 90 ||
    longitude < -180 ||
    longitude > 180
  ) {
    return null;
  }

  return { latitude, longitude };
};
